export default __webpack_public_path__ + "static/media/deprecated.bf7f0a17.jpg";